import { defineStore } from "pinia";
import { getApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";

interface Configs {
  free_ship_value?: any;
  login_image?: {
    image?: any;
  };
  most_search?: string;
  zalo_enabled?: any;
  otp_config?: any; 
  extended_cart?: {
    extended_product_category?: string;
  };
  [key: string]: any;
}

export const useConfigStore = defineStore("config", {
  state: () => ({
    configs: {} as Configs,
    configsMobile: {} as Configs,
    countDownTime: null,
    countShowPopup: 0,
  }),

  getters: {
    getConfigs(state) {
      return state.configs;
    },

    getConfigsMobile(state) {
      return state.configsMobile;
    },

    getFreeShipValue(state) {
      return state.configs?.free_ship_value || null;
    },

    getLoginImage(state) {
      return state.configs?.login_image?.image || null;
    },
    getZaloEnabled(state) {
      return state.configs?.zalo_enabled || false;
    },
    getOtpConfig(state) {
      return state.configs?.otp_config || null;
    },
    getLoyaltyConfig(state) {
      return state.configs?.loyalty_config || null;
    },
    getFlashDealConfig(state) {
      return state.configs?.flash_deal || null;
    },
    getShowCheckoutWarning(state) {
      return state.configs?.show_checkout_warning || null;
    },
    getCampaignBannerImage(state) {
      return state.configs?.campaign_banner_image || null;
    },
    getCountdownImage(state) {
      return state.configs?.countdown_image || null;
    },
    getMostSearch(state) {
      return state.configs?.most_search || null;
    },
    getColorList(state) {
      return state.configs?.color_list || null;
    },
    getDataPopUp(state) {
      let dataPopUp =
        state.configs?.popup?.length > 0
          ? state.configs?.popup?.filter(
              (e) =>
                e.status == "1" &&
                e.type_popup == "popup_coupon" &&
                new Date(`${e?.end_date}`).getTime() - new Date().getTime() + 60 * 60 * 24 * 1000 > 0
            )
          : null;
      return dataPopUp;
    },
    getDataPopUpFixTop(state) {
      let dataPopUpFixTop =
        state.configs?.popup?.length > 0
          ? state.configs?.popup?.filter(
              (e) =>
                e.status == "1" &&
                e.type_popup == "banner_fix_top" &&
                new Date(`${e?.end_date}`).getTime() - new Date().getTime() + 60 * 60 * 24 * 1000 > 0
            )
          : null;
      return dataPopUpFixTop;
    },
    getCountDownTime(state) {
      return state.countDownTime;
    },

    getCountShowPopup(state) {
      return state.countShowPopup;
    },
    getExtendedProductCategory(state) {
      return state.configs?.extended_cart?.extended_product_category || null;
    },

    getFlashDealMobile(state) {
      return state.configsMobile?.flash_deal || null;
    },
    getCustomerTax(state) {
      return state.configs?.customer_tax_info || null;
    },

    getGuestCheckout(state) {
      return state.configs?.guest_checkout || null;
    },

    getStatusSuggestion(state) {
      return state.configs?.cart_product_suggestion_enabled || null;  
    }
  },
  actions: {
    async loadConfigs() {
      try {
        const response = await getApiAxios(api.config.config_list);
        this.configs = response?.result;
      } catch (error) {
        console.error("Error fetching configs:", error);
      }
    },

    async loadConfigsMobile() {
      try {
        const response = await getApiAxios(api.config.config_list + "?storeCode=mobile");
        this.configsMobile = response?.result;
      } catch (error) {
        console.error("Error fetching configs:", error);
      }
    },

    async getConfigPopupCountdown(param: string) {
      try {
        const response = await getApiAxios(api.config.config_popup_countdown + `?popup_ids=${param}`);
        this.countDownTime = response?.result;
      } catch (error) {
        console.error("Error fetching configs:", error);
      }
    },

    setCountShowPopup(count: number) {
      this.countShowPopup = count;
    },
  },
});
